import { api } from './client';

/** FR-044: a warning an administrator sent to the signed-in member. */
export interface MemberWarning {
  id: string;
  message: string;
  createdAt: string;
  acknowledgedAt: string | null;
  reportId?: string | null;
}

/** tasks.md T176, ported from mobile/src/services/warningsApi.ts. */
export const warningsApi = {
  /** Newest first. */
  list: () => api.get<MemberWarning[]>('/accounts/me/warnings'),
  acknowledge: (warningId: string) =>
    api.post<MemberWarning>(`/accounts/me/warnings/${encodeURIComponent(warningId)}/acknowledge`),
};
